// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1573":"e98607b114434d6f","5322":"9bbbc6f85bfc9802","6972":"5c72837ffd79a769"}[chunkId] + ".js";
};